<ng-template #menuItems>
    <ul class="navbar-nav mx-auto mb-0 d-block d-lg-flex align-items-center">
        <li class="nav-item">
            <a class="nav-link fs-md-18 text-decoration-none" [routerLink]="paths.diseases" routerLinkActive="active" [innerText]="labels.diseases"></a>
        </li>
        <li class="nav-item">
            <a class="nav-link fs-md-18 text-decoration-none" href="https://resources.rarediseases.info.nih.gov/Resources/s/" [innerText]="labels.resources"></a>
        </li>
        <li class="nav-item">
            <a
                class="nav-link fs-md-18 text-decoration-none"
                [routerLink]="paths.about"
                [routerLinkActiveOptions]="{ exact: true }"
                routerLinkActive="active"
                [innerText]="labels.about"
            ></a>
        </li>
        <li class="nav-item">
            <a class="nav-link fs-md-18 text-decoration-none" [routerLink]="paths.contactUs" routerLinkActive="active" [innerText]="labels.contact"></a>
        </li>
        <li class="nav-item icon d-none d-lg-block">
            <button
                type="button"
                (click)="toggleSearch($event)"
                aria-label="Toggle search"
                [attr.aria-expanded]="isSearchOpen"
                class="search-toggle-link d-inline-flex align-items-center text-decoration-none bg-transparent border-0 p-0"
            >
                <i [ngClass]="{ 'icon-gard-search': !isSearchOpen, 'icon-gard-close': isSearchOpen }" class="search-icon d-none d-lg-flex"></i>
            </button>
        </li>
    </ul>
</ng-template>

<header class="HHS-NIH-banner" aria-label="Government agency information">
    <div class="container-xxxl">
        <div class="row">
            <div class="col-12">
                <div class="link-small container-fluid px-lg-0 d-flex white-link">
                    <a href="https://www.hhs.gov/" target="_blank" rel="noopener">
                        <img src="/assets/hhs-white.png" srcset="/assets/hhs-white.png 1x, /assets/hhs-white@2x.png 2x" width="25" height="25" alt="HHS Logo" />
                        <span class="d-none d-lg-inline small">U.S. Department of Health &amp; Human Services</span>
                    </a>

                    <a href="https://www.nih.gov/" target="_blank" rel="noopener">
                        <img src="/assets/nih-logo.png" srcset="/assets/nih-logo.png 1x, /assets/nih-logo@2x.png 2x" width="40" height="25" alt="NIH Logo" />
                        <span class="d-none d-lg-inline small">National Institutes of Health</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</header>

<div class="bg-white">
    <div class="container-xxxl">
        <div class="row">
            <div class="col-12">
                <nav class="navbar navbar-expand-lg navbar-light my-3 me-0 me-lg-3 not-styled-link" aria-label="Main navigation">
                    <div class="container-fluid px-lg-0 d-flex align-items-center flex-nowrap">
                        <a href="/" class="logo">
                            <div class="logos align-items-center d-xl-none">
                                <img src="/assets/GARD_Logo_Mobile.svg" alt="Genetic and Rare Diseases (GARD) information Center Home" />
                            </div>

                            <div class="logos align-items-center d-none d-xl-flex">
                                <img src="/assets/GARD_Logo.svg" alt="Genetic and Rare Diseases (GARD) information Center Home" />
                            </div>
                        </a>

                        <div class="d-flex d-lg-none align-items-center fs-5">
                            <div
                                role="button"
                                id="top-nav-open-menu"
                                aria-label="Toggle navigation"
                                [attr.aria-expanded]="isMenuOpen"
                                (click)="toggleMenu()"
                                aria-controls="navbarSupportedContent"
                            >
                                <i class="menu-icon me-3" [ngClass]="isMenuOpen ? 'icon-gard-close' : 'icon-gard-menu'"></i>
                            </div>

                            <button
                                type="button"
                                (click)="toggleSearch($event)"
                                aria-label="Toggle search"
                                [attr.aria-expanded]="isSearchOpen"
                                class="search-toggle-link d-inline-flex align-items-center text-decoration-none bg-transparent border-0 p-0"
                            >
                                <i class="search-icon" [ngClass]="{ 'icon-gard-search': !isSearchOpen, 'icon-gard-close': isSearchOpen }"></i>
                            </button>
                        </div>

                        <div class="menu-right collapse navbar-collapse d-none d-lg-flex" [class.show]="isMenuOpen" id="navbarSupportedContent">
                            <ng-container *ngTemplateOutlet="menuItems"></ng-container>
                        </div>
                    </div>
                </nav>
            </div>

            <div class="col-0 col-xxxl-2">
                <div class="mobile-items d-block d-lg-none position-absolute w-100 py-3" *ngIf="isMenuOpen">
                    <ng-container *ngTemplateOutlet="menuItems"></ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
